import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authApi from '../api/authApi';
import getMeCache from '../api/get-me-cache';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLogined: false,
        userInfo: {},
    },
    reducers: {
        login(state, action) {
            state.isLogined = true;
        },
        logout(state, action) {
            state.isLogined = false;
            // Không để hồ sơ của user vừa thoát rơi sang phiên đăng nhập kế tiếp.
            getMeCache.reset();
        },
        setUserInfo(state, action) {
            state.userInfo = action.payload;
        },
        /**
         * Chỉ thay danh sách thông báo, giữ nguyên phần còn lại của hồ sơ.
         * Dùng cho trang Thông báo: sau khi đọc/xoá chỉ cần tải lại notifications
         * (1 truy vấn) thay vì gọi get-me (6 truy vấn) để lấy lại cả hồ sơ.
         */
        setNotifications(state, action) {
            state.userInfo = { ...state.userInfo, notifications: action.payload };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getUserInfoByToken.fulfilled, (state, action) => {
            state.userInfo = action.payload;
            state.isLogined = true;
        });
        builder.addCase(getUserInfoByToken.rejected, (state, action) => {
            // Chỉ logout khi token THẬT SỰ sai (401). Lỗi mạng/timeout/5xx (server
            // chập chờn) là tạm thời → giữ nguyên session, tránh xoá token rồi đẩy
            // user về trạng thái "chưa đăng nhập" ở các màn như Rải link lụm tiền.
            const status = action.payload?.status;
            if (status === 401) {
                state.isLogined = false;
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_info');
            }
        });
    },
});

const authActions = authSlice.actions;
const authReducer = authSlice.reducer;

const getUserInfoByToken = createAsyncThunk(
    'auth/getUserInfoByToken',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await authApi.getUserInfo();
            return data.data.user;
        } catch (error) {
            // Trả status HTTP (nếu có) để reducer phân biệt 401 (token sai →
            // logout) với lỗi mạng/5xx tạm thời (giữ session).
            return rejectWithValue({ status: error?.response?.status });
        }
    }
);

export { authActions, getUserInfoByToken };
export default authReducer;
